<template>
  <div class="whs-feedback-fullscreen" @click.self="toggleFeedbackForm(false)">
    <div class="whs-feedback-content">
      <div class="whs-feedback-fullscreen-close whs-icon"
        @click="toggleFeedbackForm(false)"></div>
      <slot></slot>
      <div v-if="isLoading(wait.processing)" class="whs-feedback-status">
        <Status :wait="wait.processing" />
      </div>
      <div v-else-if="soldOut" class="whs-feedback-form"
        :class="{ 'is-sent': soldOut }">
        <div class="whs-feedback-form-title">Данный номер продан</div>
        <div class="whs-form-control">
          <div class="whs-form-submit" @click="reload">Обновить наличие номеров
          </div>
        </div>
      </div>
      <div v-else-if="bookError" class="whs-feedback-form"
        :class="{ 'is-sent': bookError }">
        <div class="whs-feedback-form-title">Бронирование не удалось, произведен
          возврат оплаты</div>
        <div class="whs-form-control">
          <div class="whs-form-submit" @click="reload">Попробовать еще раз</div>
        </div>
      </div>
      <div v-else-if="sent && client" class="whs-feedback-form is-sent">
        <div class="whs-feedback-form-title">Спасибо за обращение, {{
          client.firstname }}{{ client.lastname ? ' ' + client.lastname : '' }}!
        </div>
        <div class="whs-feedback-response">Наш менеджер свяжется с Вами в
          ближайшее время</div>
        <template v-if="context === 'main'">
          <div class="whs-feedback-response">Подписывайтесь на нас в соцсетях,
            чтобы всегда быть в курсе лучших предложений</div>
          <div class="whs-feedback-socials">
            <a class="whs-icon whs-vk" target="_blank"
              href="http://vk.com/club36511729"></a>
            <a class="whs-icon whs-instagram" target="_blank"
              href="https://instagram.com/wellrussia/"></a>
          </div>
        </template>
      </div>
      <div v-else-if="purchased && client" class="whs-feedback-form is-sent">
        <div class="whs-feedback-form-title">Спасибо, {{ client.firstname }}{{
          client.lastname ? ' ' + client.lastname : '' }}!</div>
        <div class="whs-feedback-response">Бронирование прошло успешно. Данные
          по
          номеру отправлены на {{ client.email }}</div>
        <div class="whs-form-control">
          <div class="whs-form-submit" @click="toggleFeedbackForm(false)">
            Закрыть
          </div>
        </div>
      </div>
      <div v-else class="whs-feedback-form" id="feedback-form">
        <div v-if="['main', 'main-pm', 'well', 'pm', 'td'].includes(context)">
          <div class="whs-feedback-form-title">Оставить заявку на бронирование
          </div>
          <div class="whs-form-control">
            <div class="whs-form-label" v-show="firstname || errors.firstname"
              :class="{ 'is-red': errors.firstname }">{{ errors.firstname ||
                'Имя'
              }}
            </div>
            <input ref="firstname" :value="firstname"
              @input="handleInput('firstname')" @keyup.enter="submitForm"
              placeholder="Имя первого гостя"
              class="whs-form-input whs-form-input-firstname" />
            <div v-if="firstname.length < 2"
              class="whs-form-input-requirator whs-icon"
              :class="{ 'is-red': errors.firstname }"></div>
          </div>
          <div class="whs-form-control">
            <div class="whs-form-label" v-show="lastname">Фамилия</div>
            <input ref="lastname" :value="lastname"
              @input="handleInput('lastname')" @keyup.enter="submitForm"
              placeholder="Фамилия"
              class="whs-form-input whs-form-input-lastname is-optional" />
          </div>
          <div class="whs-form-control">
            <div class="whs-form-label" v-show="phone || errors.phone"
              :class="{ 'is-red': errors.phone }">{{ errors.phone || 'Телефон'
              }}
            </div>
            <input ref="phone" :value="phone" @input="handleInput('phone')"
              @keyup.enter="submitForm" placeholder="Номер телефона"
              class="whs-form-input whs-form-input-phone" />
            <div v-if="phone.length < 10"
              class="whs-form-input-requirator whs-icon"
              :class="{ 'is-red': errors.phone }"></div>
          </div>
          <div class="whs-form-control">
            <div class="whs-form-label" v-show="email || errors.email"
              :class="{ 'is-red': errors.email }">{{ errors.email
                || 'Электронная почта' }}</div>
            <input ref="email" :value="email" @input="handleInput('email')"
              @keyup.enter="submitForm" placeholder="Электронная почта"
              class="whs-form-input whs-form-input-email" />
            <div v-if="!email" class="whs-form-input-requirator whs-icon"
              :class="{ 'is-red': errors.email }"></div>
          </div>

          <template v-if="context === 'main' || context === 'main-pm'">
            <div class="whs-form-control">
              <div class="whs-form-label"
                v-show="officeCity || errors.officeCity"
                :class="{ 'is-red': errors.officeCity }">{{ errors.officeCity ||
                  'Город' }}</div>
              <input ref="officeCity" :value="officeCity"
                @input="handleInput('officeCity')"
                @focus="showOptions('officeCity')"
                @blur="showOptions('officeCity', false)"
                @keyup.enter="submitForm" placeholder="Выберите город"
                class="whs-form-input whs-form-input-officeCity"
                :class="{ 'is-set': selectedOfficeCity, 'is-optional': !errors.officeCity }" />
              <div v-if="selectedOfficeCity || errors.officeCity"
                class="whs-icon" :class="{
                  'is-red': errors.officeCity,
                  'whs-hero__input-nullifier': selectedOfficeCity, 'whs-form-input-requirator': !selectedOfficeCity
                }" @click="setOfficeCity()"></div>
              <transition name="fade">
                <div v-if="optionsAreShown.includes('officeCity')"
                  class="whs-hero__result-container">
                  <div class="whs-hero__result-region whs-icon-left"
                    v-for="city in officeCities" v-bind:key="city.id"
                    @click="setOfficeCity(city.id)">{{ city.name }}</div>
                </div>
              </transition>
            </div>
            <div class="whs-form-control" v-if="selectedOfficeCity">
              <div class="whs-form-label"
                v-show="officeName || errors.officeName"
                :class="{ 'is-red': errors.officeName }">{{ errors.officeName ||
                  'Офис продаж' }}</div>
              <input ref="officeName" :value="officeName"
                @input="handleInput('officeName')"
                @focus="showOptions('officeName')"
                @blur="showOptions('officeName', false)"
                @keyup.enter="submitForm" placeholder="Выберите офис"
                class="whs-form-input whs-form-input-officeName"
                :class="{ 'is-set': selectedOffice }" />
              <div class="whs-icon"
                :class="{ 'is-red': errors.officeName, 'whs-hero__input-nullifier': selectedOffice, 'whs-form-input-requirator': !selectedOffice }"
                @click="setOfficeName()"></div>
              <transition name="fade">
                <div v-if="optionsAreShown.includes('officeName')"
                  class="whs-hero__result-container">
                  <div class="whs-hero__result-region whs-icon-left"
                    v-for="office in offices" v-bind:key="office.id"
                    @click="setOfficeName(office.id)">{{ office.name }}</div>
                </div>
              </transition>
            </div>
          </template>

          <div class="whs-form-control">
            <div class="whs-form-label" v-show="comment">Комментарий для отеля
            </div>
            <textarea placeholder="Комментарий для отеля"
              class="whs-form-input is-optional"
              @input="handleComment"></textarea>
          </div>

          <div class="whs-form-control" style="flex: unset"
            v-if="context !== 'office'">
            <div class="whs-form-checkbox whs-icon"
              :class="{ 'whs-checked': isPersonalDataChecked, 'whs-red': errors.personalData }"
              @click.self="setPersonalDataChecked" v-html="checkBoxLabel" style="margin-right: 18px;
              display: inline-block" />
          </div>

          <div class="whs-form-control">
            <div class="whs-form-submit" @click="submitForm">Отправить заявку
            </div>
          </div>
          <!-- <div v-if="context === 'well' || context === 'main'" class="whs-form-control">
            <div class="whs-form-submit whs-icon whs-icon-card" @click="payWithCard">Оплатить картой</div>
          </div>-->
        </div>
        <div v-if="context === 'office'">
          <div class="whs-feedback-form-title">Новая заявка в турадмине</div>
          <div class="whs-form-control">
            <div class="whs-form-submit" @click="copyToOffice">Копировать данные
              в
              заявку</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { invokeOnce, calcPrice } from '../api';
import { mapState, mapGetters } from 'vuex';
import Status from '../components/Status.vue';

export default {
  name: 'FeedbackForm',
  props: {
    toggleFeedbackForm: Function,
    room: Object
  },
  components: {
    Status
  },
  data: () => ({
    errors: {
      firstname: null,
      phone: null,
      email: null,
      lastname: null,
      officeCity: null,
      officeName: null,
      personalData: null,
    },
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    comment: '',
    officeCity: '',
    selectedOfficeCity: null,
    officeName: '',
    selectedOffice: null,
    optionsAreShown: [],
    isPersonalDataChecked: false,
  }),
  computed: {
    ...mapState('hotel', ['hotel']),
    ...mapState('hero', [
      'invoiceId',
      'direction',
      'checkinDate',
      'checkoutDate',
      'nightsAdults',
      'adults',
      'children',
      'officeList',
      'sent',
      'client',
      'wait',
      'soldOut',
      'bookError',
      'purchased'
    ]),
    ...mapState('hero', {
      officeCitiesAll: state => state.officeCities
    }),
    ...mapGetters(['context', 'isLoading', 'policyPageLink']),
    ...mapGetters('hero', ['price']),
    isReady: {
      get() {
        return this.firstname.length > 2 && this.phone.length > 10;
      }
    },
    officeCities: {
      get() {
        return this.officeCity.length > 0
          ? this.officeCitiesAll.filter(
            city => city.name.search(new RegExp(this.officeCity, 'i')) !== -1
          )
          : this.officeCitiesAll;
      }
    },
    offices: {
      get() {
        return this.officeList.filter(
          office => office.city === this.selectedOfficeCity.id
        );
      }
    },
    checkBoxLabel() {
      return `Я прочитал и согласен с
    <a
      target="_blank"
      href="${this.policyPageLink}"
      >политикой конфиденциальности</a
    >
    данного сайта по сбору и обработке персональных данных`;
    }
  },
  methods: {
    checkForm(card = false) {
      if (!this.firstname) {
        this.errors.firstname = 'Укажите, пожалуйста, ваше имя';
      }
      if (this.firstname.length < 2) {
        this.errors.firstname = 'Имя должно быть не короче 2 знаков';
      }
      if (!this.phone) {
        this.errors.phone = 'Укажите, пожалуйста, ваш телефон';
      }
      if ((this.context === 'main' || this.context === 'main-pm') && !card) {
        if (!this.selectedOfficeCity) {
          this.errors.officeCity = 'Укажите, пожалуйста, ваш город';
        }
        if (!this.selectedOffice) {
          this.errors.officeName = 'Укажите, пожалуйста, офис продаж';
        }
      }
      if (this.phone.length < 10) {
        this.errors.phone = '10-значный номер, пример: 9267774433';
      }
      if (!this.email || !this.validEmail(this.email)) {
        this.errors.email = 'Укажите, пожалуйста корректный адрес.';
      }

      if (this.context !== 'office' && !this.isPersonalDataChecked) {
        this.errors.personalData = 'Подтвердите согласие';
      }

      if (Object.values(this.errors).every(value => value === null)) {
        return true;
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    setOfficeCity(id) {
      this.selectedOfficeCity = id
        ? this.officeCitiesAll.find(city => city.id === id)
        : null;
      this.officeCity = id ? this.selectedOfficeCity.name : '';
      this.selectedOffice = null;
      this.officeName = '';
      this.errors.officeCity = null;
    },
    setOfficeName(id) {
      this.selectedOffice = id
        ? this.offices.find(office => office.id === id)
        : null;
      this.officeName = id ? this.selectedOffice.name : '';
      this.errors.officeName = null;
    },
    nullify(name) {
      if (name === 'officeCity') {
        this.setOfficeCity();
      }
      if (name === 'officeName') {
        this.setOfficeName();
      }
    },
    handleInput(name) {
      if (this.errors[name]) this.errors[name] = null;
      const value = window.event.target.value;
      invokeOnce(() => (this[name] = value), 250);

      if (this.selectedOfficeCity && name === 'officeCity')
        this.setOfficeCity();
      if (this.selectedOffice && name === 'officeName') this.setOfficeName();
    },
    handleSelect(name) {
      if (this.errors[name]) this.errors[name] = null;
      const value = window.event.target.value;
      invokeOnce(() => (this[name] = value), 250);
    },
    handleComment() {
      this.comment = window.event.target.value;
    },
    showOptions(name, show = true) {
      if (show) this.optionsAreShown.push(name);
      else this.optionsAreShown.splice(this.optionsAreShown.indexOf(name), 1);
    },
    setPersonalDataChecked() {
      this.isPersonalDataChecked = !this.isPersonalDataChecked;
      if (this.isPersonalDataChecked) {
        this.errors.personalData = null;
      }
    },
    submitForm() {
      if (!this.checkForm()) return;

      const { meal, room_name, hotelpage } = this.room;
      const b2b_recommended_price = calcPrice(this.room);
      const { country, city, name: hotelname } = this.hotel.info;
      const office =
        this.context === 'main' || this.context === 'main-pm'
          ? this.selectedOffice.id
          : process.env.NODE_ENV !== 'production'
            ? this.context === 'well'
              ? 'pro.well.ru'
              : '123.putevkamarket.ru'
            : window.location.host;
      const href = encodeURIComponent(
        `${this.context === 'well' || this.context === 'main'
          ? 'https://office.well.ru/hotels/'
          : 'https://agent.putevkamarket.ru/hotels/'
        }` + window.location.hash
      );
      this.$store.dispatch('hero/sendClientData', {
        client: {
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          phone: this.phone,
          comment: this.comment
        },
        office,
        room: {
          country,
          city,
          hotelname,
          meal,
          room_name,
          b2b_recommended_price,
          hotelpage: encodeURIComponent(hotelpage),
          href,
          guests:
            this.adults +
            ' взр' +
            (this.children.length > 0
              ? `,${this.children.length} детей ${this.children.join(',')} лет`
              : ''),
          nights: (this.checkoutDate - this.checkinDate) / 86400000,
          checkin: this.checkinDate.toLocaleDateString('ru-RU'),
          checkout: this.checkoutDate.toLocaleDateString('ru-RU')
        },
        context: this.context
      });
    },
    copyToOffice() {
      const { meal, room_name } = this.room;
      const b2b_recommended_price = calcPrice(this.room);
      const {
        country,
        city,
        name: hotelname,
        clean_address,
        description_short
      } = this.hotel.info;

      this.$store.dispatch('hero/copyToOffice', {
        country,
        city,
        hotelname,
        meal,
        room_name,
        b2b_recommended_price: this.price(b2b_recommended_price),
        clean_address,
        description_short,
        hotelpage: window.location.href,
        cancellation_info: this.$parent.getCancelationInfo(this.room),
        guests:
          this.adults +
          ' взрослых' +
          (this.children.length > 0
            ? `, ${this.children.length} детей ${this.children.join(', ')} лет`
            : ''),
        nights: (this.checkoutDate - this.checkinDate) / 86400000,
        checkin: this.checkinDate.toLocaleDateString('ru-RU'),
        checkout: this.checkoutDate.toLocaleDateString('ru-RU')
      });
    },
    payWithCard() {
      this.fillForm();
      if (!this.checkForm(true)) return;

      const { meal, room_name, rate_price, book_hash } = this.room;
      const b2b_recommended_price = calcPrice(this.room);
      const {
        country,
        city,
        name: hotelname,
        clean_address,
        description_short
      } = this.hotel.info;

      const hotel = {
        country,
        city,
        hotelname,
        meal,
        room_name,
        rate_price,
        book_hash,
        b2b_recommended_price,
        clean_address,
        description_short,
        hotelpage: window.location.href,
        cancellation_info: this.$parent.getCancelationInfo(this.room),
        guests:
          this.adults +
          ' взрослых' +
          (this.children.length > 0
            ? `, ${this.children.length} детей ${this.children.join(', ')} лет`
            : ''),
        nights: (this.checkoutDate - this.checkinDate) / 86400000,
        checkin: this.checkinDate.toLocaleDateString('ru-RU'),
        checkout: this.checkoutDate.toLocaleDateString('ru-RU')
      };

      this.$store.dispatch('hero/getInvoiceId').then(() => {
        const office =
          this.context === 'main'
            ? 'well.ru'
            : process.env.NODE_ENV !== 'production'
              ? this.context === 'well'
                ? 'pro.well.ru'
                : '123.putevkamarket.ru'
              : window.location.host;
        const widget = new window.cp.CloudPayments();
        widget.auth(
          {
            // publicId: 'pk_a97cab9f045fdb91c794eed7b4056', // велл
            publicId: 'pk_7cf302d7198d14e1dfeb60b6ef1d5', // тестовый велл
            // publicId: 'test_api_00000000000000000000001', // тестовый
            description: 'Оплата за проживание в номере', //назначение
            amount: parseFloat(calcPrice(this.room)), //сумма
            currency: 'RUB', //валюта
            invoiceId: `whs-${this.invoiceId}`, //номер заказа  (необязательно)
            accountId: this.email, //идентификатор плательщика (необязательно)
            skin: 'mini', //дизайн виджета
            email: this.email,
            requireEmail: true,
            data: {
              client: {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                phone: this.phone,
                comment: this.comment
              },
              hotel,
              office,
              amount: parseFloat(calcPrice(this.room))
            }
          },
          options => {
            // success
            this.$store.dispatch('hero/approveInvoice', {
              id: this.invoiceId,
              data: options.data
            });
          },
          (/* reason, options */) => {
            // fail
            this.$store.dispatch('hero/dropInvoiceId', this.invoiceId);
          }
        );
      });
    },
    fillForm() {
      this.firstname = 'Семен';
      this.lastname = 'Ostrovok';
      this.phone = 123456789;
      this.email = 'uvarov@well.ru';
    },
    reload() {
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.whs-feedback-fullscreen {
  z-index: 9000;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: var(--color-text-5);
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
}

.whs-feedback-fullscreen-close:before {
  width: 100%;
  content: '\f00d';
  text-align: center;
  color: var(--color-main);
  font-size: 18px;
}

.whs-feedback-status {
  flex: 1 1 300px;
  background-color: var(--color-bg);
  padding: 60px 20px;
}

.whs-feedback-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: stretch;
  align-items: stretch;
  max-width: 1200px;
  border-radius: 4px;
  /* overflow-x: hidden; */
  min-height: 60vh;
  position: relative;
}

.whs-feedback-fullscreen-close {
  position: absolute;
  left: unset;
  top: 0;
  right: 0;
  cursor: pointer;
  padding: 8px 12px;
  background-color: var(--color-bg);
}

.whs-feedback-form {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  flex-wrap: wrap;
  padding: 32px 24px;
  background-color: var(--color-bg);
  flex: 1 1 300px;
}

.whs-feedback-form-title {
  font-size: 18px;
  padding: 0 8px 8px;
  width: 100%;
  text-align: center;
}

.whs-form-control {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: 8px;
}

.whs-form-label {
  padding: 4px 12px;
  position: absolute;
  font-size: 11px;
  color: var(--color-text-5);
  font-weight: 600;
  pointer-events: none;
}

.whs-form-input {
  width: 100%;
  background-color: #fff;
  outline: none;
  line-height: 16px;
  padding: 20px 12px 8px;
  border: 1px solid var(--color-alt-5);
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px;
}

.whs-form-input.is-set {
  background-color: var(--color-bg);
  transition: background-color 0.3s;
}

.whs-form-input.is-set:hover {
  background-color: #fff;
  transition: background-color 0.3s;
}

.whs-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}

.whs-form-input:focus::placeholder {
  color: var(--color-alt);
}

.whs-form-input:focus {
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}

.whs-form-submit {
  width: 100%;
  /* background: linear-gradient(var(--color-alt) -50%, var(--color-main)); */
  background: var(--color-button);
  outline: none;
  padding: 14px 20px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
}

.whs-form-submit:hover {
  /* background: linear-gradient(
    to top,
    var(--color-second) -20%,
    var(--color-second-alt) 150%
  ); */
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
}

.whs-form-submit.is-disabled,
.whs-form-submit.is-disabled:hover {
  background: linear-gradient(var(--color-alt) -50%, var(--color-main));
  border-bottom: 2px solid var(--color-alt);
  opacity: 0.5;
  cursor: wait;
}

.whs-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}

.whs-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text);
  font-size: 12px;
}

.is-red,
.is-red:before {
  color: var(--color-second);
}

.is-optional {
  background-color: var(--color-bg);
  transition: background-color 0.3s;
}

.is-optional:hover,
.is-optional:focus {
  background-color: #fff;
  transition: background-color 0.3s;
}

.whs-hero__result-container {
  max-height: 300px;
  overflow-y: auto;
}

/* response */
/* .is-sent {
  justify-content: center;
} */
.whs-feedback-response {
  padding: 12px 8px;
  text-align: center;
}

.whs-feedback-socials {
  display: flex;
}

.whs-vk,
.whs-instagram {
  margin: 8px;
  background-color: var(--color-main);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.whs-vk:before,
.whs-instagram:before {
  content: '\f189';
  width: 100%;
  font: 28px 'Font Awesome 5 Brands';
  color: #fff;
  text-align: center;
}

.whs-instagram:before {
  content: '\f16d';
  font-size: 32px;
}

.whs-icon-card:before {
  content: '\f09d';
  margin-right: 12px;
  color: #fff;
  font-size: 18px;
}
</style>